import styled, { css } from 'styled-components';

import DialogRoundedModal, { ModalBody, ModalActionButton } from '../../../../../../../components/DialogRoundedModal';
import { HeaderContainer, ActionsContainer } from '../../../../../../../components/DialogRoundedModal/styles';
import colors from '../../../../../../../styles/colors';

const SummaryModal = styled(DialogRoundedModal)`
  ${HeaderContainer} {
    padding: 22px 24px 12px;
  }

  ${ModalBody} {
    padding: 12px 24px;
  }

  ${ActionsContainer} {
    margin-top: 0;
    padding: 14px 24px 22px;
  }
`;

const bodyText = css`
  font-size: 13px;
  line-height: 1.45;
`;

const Spark = styled.span`
  color: ${colors.base.primary};
  font-size: 14px;
`;

const Message = styled.div`
  ${bodyText}
  color: ${colors.shades.gamma10};
`;

const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

const ActionButtonsRow = styled.div`
  display: flex;
  column-gap: 16px;
`;

const SecondaryActionButton = styled(ModalActionButton)`
  background: transparent;
  color: ${colors.shades.beta2};
  border: 1px solid ${colors.shades.gamma3};

  &:disabled {
    background: transparent;
    border-color: ${colors.shades.gamma1};
  }
`;

const Warning = styled.div`
  font-size: 12px;
  line-height: 16px;
  font-weight: bold;
  color: ${colors.base.warning};
`;

const LoadingRow = styled(Message)`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const BulletList = styled.ul`
  ${bodyText}
  margin: 0;
  padding-left: 18px;
  max-height: 240px;
  overflow-y: auto;
  color: ${colors.base.secondary2};

  li::marker {
    color: ${colors.base.secondary};
  }

  li + li {
    margin-top: 8px;
  }
`;

export {
  SummaryModal,
  Spark,
  Message,
  Warning,
  Actions,
  ActionButtonsRow,
  SecondaryActionButton,
  LoadingRow,
  BulletList,
};
